import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import LessonThumbnail from '@unicons-comp/LessonsList/LessonThumbnail';
import React from 'react';

interface ContinueWatchingCardProps {
  watchedDuration: number | null;
  duration: number;
  slug: string;
  cover: string;
  title: string;
  order: number;
  course: any;
}

const CardWrapper = styled.div``;

const Subtitle = styled.div`
  font-size: ${Fonts.EXTRA_SMALL};
  text-transform: uppercase;
  font-weight: ${Fonts.BOLD};
  color: var(--color-i-icon-dark-secondary);
  margin-top: ${Spacings.SPACING_4B};
  &::selection {
    color: var(--color-i-all-black);
    background: var(--color-i-icon-light-tertiary);
  }
`;

const CourseTitle = styled.span`
  margin-right: ${Spacings.SPACING_3};
  &::selection {
    color: var(--color-i-all-black);
    background: var(--color-i-icon-light-tertiary);
  }
`;

const LessonCount = styled.span`
  margin-left: ${Spacings.SPACING_3};
  &::selection {
    color: var(--color-i-all-black);
    background: var(--color-i-icon-light-tertiary);
  }
`;

const LessonTitle = styled.h4`
  font-size: ${Fonts.H5};
  color: var(--color-i-icon-light-tertiary);
  margin-top: ${Spacings.SPACING_2B};
  font-weight: ${Fonts.SEMIBOLD};
  &::selection {
    color: var(--color-i-all-black);
    background: var(--color-i-icon-light-tertiary);
  }
`;

const ContinueWatchingCard: React.FC<ContinueWatchingCardProps> = ({
  slug,
  course,
  title,
  cover,
  order,
  duration,
  watchedDuration
}) => {
  const continueWatching = watchedDuration ? { watchedDuration } : null;
  return (
    <CardWrapper>
      <LessonThumbnail
        cover={cover}
        courseSlug={course?.slug}
        duration={duration}
        continueWatching={continueWatching}
        slug={slug}
        isSubscribed
        desktopHeight="194px"
        mobileHeight="178px"
        isFullWidth
      />
      <Subtitle>
        <CourseTitle>{course?.title}</CourseTitle>•
        <LessonCount>Lesson {order}</LessonCount>
      </Subtitle>
      <LessonTitle>{title}</LessonTitle>
    </CardWrapper>
  );
};

ContinueWatchingCard.displayName = 'ContinueWatchingCard';

export default ContinueWatchingCard;
